import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const WalletModalContext = createContext(null);

export function WalletModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

  return <WalletModalContext.Provider value={value}>{children}</WalletModalContext.Provider>;
}

/**
 * useWalletModal
 * Any button anywhere under <WalletModalProvider> can call
 * `useWalletModal().open()` to pop the Connect Wallet modal.
 */
export function useWalletModal() {
  const ctx = useContext(WalletModalContext);
  if (!ctx) {
    throw new Error('useWalletModal must be used inside <WalletModalProvider>');
  }
  return ctx;
}